import React, {createContext, useEffect, useState} from 'react';
import { Modal } from 'react-bootstrap';
import {Player} from "@lottiefiles/react-lottie-player";
import loading from "../../_asset/lottie/loading.json"

interface LOADING_INTERFACE {
    SetLoadingPop: Function
}

export const loadingContext = createContext<LOADING_INTERFACE>({
    SetLoadingPop: () => {}
})


export default function GameLoading({children}: {children: React.ReactNode}) {
    const [loading, showLoading] = useState<boolean>(true)

    function SetLoadingPop(isOn: boolean){
        showLoading(isOn)
    }
    return (
        <loadingContext.Provider value={{SetLoadingPop}}>
            {children}
            {
                loading ? <LoadingModal showLoading={showLoading}/> : <></>
            }
        </loadingContext.Provider>
    );
}

export function LoadingModal({showLoading}: {showLoading: Function}){
    return (
        <Modal show={true}
               onHide={()=> showLoading(false)}
               className={'loading-modal'}
        >
            <Modal.Body>
                <Player src={loading} loop autoplay={true}
                        style={{width: '15rem', height: '15rem'}}></Player>
            </Modal.Body>
        </Modal>
    )
}